import React from 'react';
import { Button, FlexBox, Modal } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import '../GeneratedCreatives.scss';

type BannerMobileModal = {
  bannerUrl: string;
  onClose: () => void;
};
const ZoomImageModal = ({ bannerUrl, onClose }: BannerMobileModal) => {
  return (
    <Modal className="zoom-image-modal" offClick={onClose}>
      <FlexBox flexDirection="column" alignItems="center">
        <Button onClick={onClose} UNSAFE_className="modal_cross">
          <FontAwesomeIcon icon={faTimes} style={{ cursor: 'pointer', fontSize: '24px' }} />
        </Button>
        <FlexBox UNSAFE_className="mobile-modal-content">
          <img src={bannerUrl} alt="generated banner" />
        </FlexBox>
      </FlexBox>
    </Modal>
  );
};

export default ZoomImageModal;
